import { jsx as o } from "react/jsx-runtime";
const i = ({
  size: C = 16,
  color: n = "currentColor",
  strokeWidth: r = 1.5,
  ...t
}) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: C,
    height: C,
    viewBox: "0 0 32 32",
    fill: "none",
    ...t,
    children: /* @__PURE__ */ o(
      "path",
      {
        d: "M18.9336 9.41333H22.0499C22.3761 9.41333 22.5391 9.41333 22.6926 9.45017C22.8286 9.48283 22.9587 9.53671 23.078 9.60981C23.2125 9.69227 23.3278 9.80757 23.5584 10.0382L28.9754 15.4552C29.206 15.6858 29.3213 15.8011 29.4038 15.9356C29.4769 16.0549 29.5308 16.185 29.5634 16.321C29.6003 16.4745 29.6003 16.6375 29.6003 16.9637V20.7467C29.6003 21.3679 29.6003 21.6785 29.4988 21.9236C29.3634 22.2503 29.1039 22.5098 28.7772 22.6452C28.5321 22.7467 28.2215 22.7467 27.6003 22.7467M20.9336 22.7467H18.9336M18.9336 22.7467V9.68C18.9336 8.18652 18.9336 7.43979 18.6429 6.86936C18.3873 6.36759 17.9793 5.95964 17.4776 5.70398C16.9071 5.41333 16.1604 5.41333 14.6669 5.41333H7.20026C5.70679 5.41333 4.96005 5.41333 4.38962 5.70398C3.88785 5.95964 3.47991 6.36759 3.22424 6.86936C2.93359 7.43979 2.93359 8.18652 2.93359 9.68V20.08C2.93359 21.5528 4.1275 22.7467 5.60026 22.7467M18.9336 22.7467H13.6003M13.6003 22.7467C13.6003 24.9558 11.8094 26.7467 9.60026 26.7467C7.39112 26.7467 5.60026 24.9558 5.60026 22.7467M13.6003 22.7467C13.6003 20.5375 11.8094 18.7467 9.60026 18.7467C7.39112 18.7467 5.60026 20.5375 5.60026 22.7467M27.6003 23.4133C27.6003 25.2543 26.1079 26.7467 24.2669 26.7467C22.426 26.7467 20.9336 25.2543 20.9336 23.4133C20.9336 21.5724 22.426 20.08 24.2669 20.08C26.1079 20.08 27.6003 21.5724 27.6003 23.4133Z",
        stroke: n,
        strokeWidth: r,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
);
export {
  i as ShippingIcon
};
